import React, { useState } from 'react';

import { Typography } from '@mui/material'

import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { SignOutButton } from './office365auth/SignOutButton';

import { ContinuarMasTardeButton } from './ContinuarMasTardeButton';
import { setProgress } from './Progreso';

export const getPlanesAcademicos = (studentInfo) => {
    if (studentInfo == null) return null;
    //let planes = ((!studentInfo) ? [] : studentInfo).filter(x => x.matricula);
    let planes = ((!studentInfo) ? [] : studentInfo).filter(x => x.matricula);

    const invalidStates = [0, 1, 3];
    let validPlanes = planes.filter((x) => !invalidStates.includes(x.estado.valor));

    if (validPlanes.length) return validPlanes;
    if (planes.length) return [planes[0]];
    return [];
};

const NoPlanesDisponibles = ({ studentInfo }) => {
    const mensaje = studentInfo?.[0]?.estado?.mensajeportal || " Actualmente el portal no esta disponible para tu plan de estudios, consulta a tu coordinador académico.";
    const valor = studentInfo?.[0]?.estado?.valor 
    const serie = studentInfo?.[0]?.estado?.serie 
    const numero = studentInfo?.[0]?.estado?.numero
    return (<>
        <Container>
            <Row>
                <Col>
                    <Typography variant="h6" sx={{ my: 3 }}>
                        {mensaje}
                    </Typography>
                     <Typography variant="body2" sx={{ my: 3 }}>
                        {studentInfo?.[0]?.estado!=null ? 'Estado: '+valor+', Serie: '+serie+', Número: '+numero:''}
                    </Typography>
                    <br/>
                    <SignOutButton />
                </Col>
            </Row>
        </Container>
    </>);
};

const PlanesAcademicos = ({ planesAcademicos, onPlanChange }) => {
    const [selectedValue, setSelectedValue] = useState(null);

    const onChangeHandler = (id) => {
        onPlanChange(id);
        setSelectedValue(id);
    };

    return <>
        {
            planesAcademicos.map((plan, key) => {
                const radioProps = {
                    className: "form-check-input",
                    type: "radio",
                    name: "planesAcademicos",
                    id: `planAcademico_${plan.planacademico}`,
                    value: plan.planacademico,
                    checked: selectedValue === plan.planacademico,
                    //onChange: props.onChange(plan.planacademico),
                    //checked: (key === 0),
                };

                return (
                    <label key={key} htmlFor={radioProps.id}
                        className={"form-check plan-academico-radiobutton " + (radioProps.checked ? "checked" : "")}>

                        <input {...radioProps} onChange={() => onChangeHandler(plan.planacademico)} />

                        <label className="form-check-label" htmlFor={`planAcademico_${plan.planacademico}`}
                            style={{ fontWeight: 500 }}>
                            {plan.descrgrado} {plan.descrprograma}
                        </label>
                    </label>
                );
            })
        }
    </>
};

/**
 * Renders SeleccionarPlanAcademico component
 */
export default function SeleccionarPlanAcademico({ studentInfo, onContinuar }) {
    const [selectedPlan, setSelectedPlan] = useState(null);

    if (studentInfo == null) return (<>Cargando...</>);
    if (!studentInfo.length) return (<>Cargando...</>);

    let planesAcademicos = getPlanesAcademicos(studentInfo);

    //Si el estudiante no tiene planes academicos disponibles
    if (planesAcademicos.length === 0) {
        return <NoPlanesDisponibles studentInfo={studentInfo} />
    }

    //if (planesAcademicos.length > 1) planesAcademicos.pop();

    if (planesAcademicos.length === 1) {
        onContinuar(planesAcademicos[0].planacademico);
        return null;
    }

    const handlePlanChange = (selectedPlan) => {
        if (!selectedPlan) return;
        setSelectedPlan(selectedPlan);
    };

    const handleContinuar = () => {
        if (!selectedPlan) return;
        onContinuar(selectedPlan);
    };

    setProgress(5, 'Selecciona tu plan académico');

    return (<>
        <Container>
            <Row>
                <Col>
                    <p>Te encuentras activo en más de un plan académico.</p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="blue-label">
                        Para continuar, elige en cuál deseas reinscribirte ahora mismo.
                    </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <PlanesAcademicos
                        planesAcademicos={planesAcademicos}
                        selectedPlan={selectedPlan}
                        onPlanChange={handlePlanChange} />
                </Col>
            </Row>

            <Row>
                <Col className="d-grid gap-2 mt-5 mb-2">
                    <Button variant="primary" disabled={(!selectedPlan) ? "disabled" : ""} onClick={() => handleContinuar()}>
                        Continuar
                    </Button>
                </Col>
            </Row>

            <ContinuarMasTardeButton />
        </Container>
    </>);
}
